import { render, staticRenderFns } from "./choosePaperDialog.vue?vue&type=template&id=760df03f"
import script from "./choosePaperDialog.vue?vue&type=script&lang=js"
export * from "./choosePaperDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports